import { WfnInput } from '@adp-wfn/mdf-wc-react';
import React from 'react';
import { Field } from './types';

/**
 * String input field component
 * @param props - Field component props
 * @param props.id - Unique field identifier
 * @param props.data - Field configuration and value
 * @param props.onChange - Callback function for value changes
 * @returns JSX element for string input field
 */
export function String({ id, data, onChange }: Field) {
  return (
    <WfnInput
      id={id}
      label={data.label}
      required={data.required}
      tooltipText={data.tooltipText}
      value={data.value || ''}
      onSdfChange={(event) => onChange(event?.detail)}
    />
  );
}
